import { render, staticRenderFns } from "./T1PogodaKlimatContent.vue?vue&type=template&id=d74e0970&scoped=true&"
import script from "./T1PogodaKlimatContent.vue?vue&type=script&lang=js&"
export * from "./T1PogodaKlimatContent.vue?vue&type=script&lang=js&"
import style0 from "./T1PogodaKlimatContent.vue?vue&type=style&index=0&id=d74e0970&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d74e0970",
  null
  
)

export default component.exports